import type React from "react";
import { styled } from "@mui/material/styles";
import TablePagination, {
  type TablePaginationProps,
} from "@mui/material/TablePagination";

const SbuxStyledTablePagination = styled(TablePagination)(() => ({
  "& .MuiTablePagination-selectLabel": {
    fontSize: 13,
    margin: 0,
    alignSelf: "center",
  },
  "& .MuiTablePagination-select": {
    fontSize: 13,
    paddingTop: 0,
    paddingBottom: 0,
  },
  "& .MuiTablePagination-input": {
    alignSelf: "center",
    margin: 0,
    marginRight: 16,
  },
  "& .MuiTablePagination-displayedRows": {
    fontSize: 13,
    margin: 0,
    alignSelf: "center",
  },
  "& .MuiSvgIcon-root": {
    fontSize: 21,
  },
  "& .MuiTablePagination-toolbar": {
    padding: 0,
    paddingLeft: 8,
    minHeight: 54,
    alignItems: "center",
  },
  "&.MuiTablePagination-root": {
    borderBottom: "1px solid #fff !important",
  },
})) as React.ComponentType<TablePaginationProps<"div">>;

export default SbuxStyledTablePagination;
